module.exports = __webpack_public_path__ + "img/web_5_2x.0494fc03.png";